import type {ApiResponse} from '../types';

import {baseLogger} from './log-middleware';

export const safeParseResponseBody = async (logger = baseLogger, response: Response) => {
  try {
    // TODO: remove this after (PRE-2427)[https://linear.app/linxsecurity/issue/PRE-2427/[bug]-error-response-isnt-returned-in-the-expected-structure] is done
    if (response.body instanceof ReadableStream) {
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let result = ``;
      let isDone = false;
      while (!isDone) {
        const {done, value} = await reader.read();
        isDone = done;
        result += decoder.decode(value);
      }
      return result;
    }
    const body = (await response.json()) as ApiResponse;
    return body;
  } catch (error) {
    logger.error(error, `Error parsing response body`);
    return null;
  }
};
